<template>
<div id="etips" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="eNotes" class="elevation-1 px-5 py-3" >
                    <v-card-actions style = "margin-top:-50px;" v-if="etips.length >0" >
                        <v-spacer></v-spacer>
                        <v-btn small outlined color="red" @click="generaPDF" title="Exportar a PDF" >
                            <v-icon>mdi-file-pdf-box</v-icon>

                        </v-btn>
                            <v-btn small outlined color="blue" @click="saveDocx" title="Exportar a Word" >
                            <v-icon>mdi-file-word-box</v-icon> 

                        </v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <label class="red--text" v-if="etips.id == 0" >No se encontró ninguna nota registrada</label>
                       
                        <v-row  >
                            <v-col cols="3" style=" height:500px;  overflow-y:auto; background-color: white;" >
                                        
                                        <ul id="example-1" >
                                            <li v-for="(item, index) in etips" :key="index" v-show="item.tab1== 1 || item.tab2== 1 || item.tab3== 1 " >
                                                <a href="#" v-scroll-to="{
                                                el: '#menu-' + index ,
                                                container: '#contenedor'
                                            }" >
                                                {{ item.titulo }}
                                            </a>
                                            </li>
                                           
                                        </ul>
                                   
                            </v-col>

                            

                            <v-col  id="contenedor"  class="d-flex text-center" style="max-height:500px; overflow-y:auto;  background-color: white;" >

                                <div id="htmlSource" class="manual" >
                                    <div v-for="(item, index) in etips" :key="index" :id="'menu-' + index" >
                                        <div v-if="item.tab1== 1 || item.tab2== 1 || item.tab3== 1 " >
                                            <h2>{{ item.titulo }}</h2>
                                            <h4>{{ item.subtitulo }}</h4>
                                            <div v-if="item.tab1== 1 " >
                                                <h5>{{ item.tab1_titulo }}</h5>
                                                <div class="global" v-html="item.tab1_contenido" :key="index + 1000" />
                                            </div>
                                            <div v-if="item.tab2== 1 " >
                                                <h5>{{ item.tab2_titulo }}</h5>
                                                <br />
                                                <div class="global" v-html="item.tab2_contenido" :key="index + 2000" />

                                            </div>
                                            <div v-if="item.tab3== 1 " >
                                                <h5>{{ item.tab3_titulo }}</h5>
                                                <br />
                                                <div class="global" v-html="item.tab3_contenido" :key="index + 3000" />

                                            </div>
                                            <br />
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import Vue from 'vue'
import { asBlob } from 'html-docx-js-typescript'
// if you want to save the docx file, you need import 'file-saver'
import { saveAs } from 'file-saver'

export default {
    data: () => ({

        fab: false,
        URL: "",
        etips: [],
        show_loading: true,
        title_catalogo: "eNotes",
        columnDefs: null,
        rowData: null,
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "eNotes",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",

    }),

    methods: {
       async saveDocx() {
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
           let htmlString = document.getElementById("htmlSource").innerHTML;
          
           htmlString = `<!DOCTYPE html>
                        <html lang="es" >
                        <head><meta charset="UTF-8" >
                            <title>eNotes</title>
                        </head>
                        <body>` + htmlString + `</body>
                        </html>`;
            const fileData = await asBlob(htmlString) // asBlob() return Promise<Blob|Buffer>
            saveAs(fileData, 'eNotes.docx') // save as docx file
            this.$root.$dialogLoader.hide();
        },

        cargar: function () {
            this.etips = [];
            let data = {
                    id_cliente: this.$local_storage.get('id_cliente')
                };
                var self = this;
                axios
                    .post(this.$hostname + "configuracion/enotes/get_enotes_cliente/", data, {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    })
                    .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.etips = res.data;
                        self.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                  
                   console.log(err);
                    self.$root.$dialogLoader.hide();
                });
        },
        generaPDF: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let html = document.getElementById("htmlSource");

            var opt = {
                margin: [1, 0.5, 1, 0.5], //top, left, bottom, right
                filename: "eNotes.pdf",
                image: {
                    type: "jpeg",
                    quality: 0.5
                },
                html2canvas: {
                    scale: 1
                },
                pagebreak: {
                    mode: ["css", "legacy"] 
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait"
                }
            };
            var thisObj = this;
            html2pdf()
                .set(opt)
                .from(html)
                .toPdf().get('pdf')
                .then(function (pdf) {
                    var totalPages = pdf.internal.getNumberOfPages();

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(10);
                        pdf.setTextColor(150);
                        pdf.text("Econnect ProControl - eNotes     ", pdf.internal.pageSize.getWidth() - 3.2, .8);
                        pdf.text('_________________________________________________________________________________________________',
                            .5, .85);
                        /*  pdf.text('_________________________________________________________________________________________________',
                             .5, pdf.internal.pageSize.getHeight() - 1.3); */
                        pdf.text("" + i, pdf.internal.pageSize.getWidth() - .6, pdf.internal.pageSize.getHeight() - 1.1);
                    }
                    thisObj.$root.$dialogLoader.hide();
                })
                .save();

        }
    }, //methods
    mounted: function () {
        this.URL = this.$hostname;
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        this.cargar();
    },
    created(){
       
    }
};
</script>

<style scoped>
.global {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
    font-size: small;
}

.manual {
    margin: 0px;
    padding: 0px;
    height: auto;
    width: 680px;
    background: #fff;
    text-align: justify;
}

h3 {
    font-family: Arial, sans-serif;
    color: navy;
    font-size: x-large;
    font-weight: bold;
    
}

h4 {
    font-family: Arial, sans-serif;
    font-size: medium;
    font-weight: bold;
    margin-left: 20px;
    font-style: italic;
    color: gray;
}

h5 {
    font-family: Arial, sans-serif;
    font-size: small;
    margin-left: 20px;
    font-weight: bold;
}
</style>
